// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QEMMi","clinicsSelect":"styles_clinicsSelect__xQyFh"};